import React, { useContext, useEffect, useState } from "react";
import Spinner from "../components/Spinner";
import PositiveSSLSeal from "../components/PositiveSSLSeal";
import StarekContext from "../context/StarekContext";
import { redirect, useNavigate } from "react-router-dom";
import { proxies } from "../services/RepositoryService";

function Login(props) {
    const navigator = useNavigate();
    const starekContext = useContext(StarekContext);
    const [showSpinner, setShowSpinner] = useState(false);

    const [workspace, setWorkspace] = useState(
        starekContext?.lastUsedWorkspace?.workspace_id
    );
    const [termsAccepted, setTermsAccepted] = useState(
        localStorage.getItem("termsAccepted") === "true"
    );
    const [username, setUsername] = useState(null);
    const [password, setPassword] = useState(null);

    useEffect(() => {
        localStorage.setItem("termsAccepted", termsAccepted);
    }, [termsAccepted]);

    return (
        <div className="login-page">
            <div className="login-box">
                <div
                    className="login-logo d-flex flex-column align-items-center justify-content-center"
                    style={{ marginBottom: "1rem" }}
                >
                    <img
                        src="/dist/img/light-starek-brand-512x512.png"
                        alt="Starek"
                        className="brand-image elevation-3"
                        style={{ opacity: "0.8" }}
                    />
                </div>

                {/* Workspace field at the top */}
                <div className="mb-4">
                    <div className="input-group has-validation">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Workspace"
                            onChange={(e) => setWorkspace(e.target.value)}
                            value={workspace}
                        />
                        <div className="input-group-append">
                            <div className="input-group-text">
                                <span className="fas fa-globe" />
                            </div>
                        </div>
                        <div className="invalid-feedback">
                            Please provide your workspace
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body login-card-body">
                        <>
                            <div className="input-group has-validation mb-3">
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Email"
                                    onChange={(e) =>
                                        setUsername(e.target.value)
                                    }
                                />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-envelope" />
                                    </div>
                                </div>
                                <div className="invalid-feedback">
                                    Please provide your username
                                </div>
                            </div>
                            <div className="input-group has-validation mb-3">
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Password"
                                    onChange={(e) =>
                                        setPassword(e.target.value)
                                    }
                                />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-lock" />
                                    </div>
                                </div>
                                <div className="invalid-feedback">
                                    Please provide your password
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-8">
                                    <p className="mb-1">
                                        <a href="forgot-password">
                                            Trouble Signing-in?{" "}
                                        </a>
                                    </p>
                                </div>
                                <div className="col-4">
                                    <button
                                        className="btn btn-primary btn-block"
                                        disabled={!termsAccepted}
                                        onClick={async () => {
                                            try {
                                                setShowSpinner(true);
                                                await starekContext?.login(
                                                    workspace,
                                                    username,
                                                    password
                                                );
                                                setShowSpinner(false);
                                                const redirectPath =
                                                    sessionStorage.getItem(
                                                        "postAuthRedirect"
                                                    ) || "/";
                                                navigator(redirectPath);
                                            } catch (e) {
                                                starekContext?.showError(
                                                    "Sign in failed: Please check Workspace, Username and Password."
                                                );
                                                setShowSpinner(false);
                                            }
                                        }}
                                    >
                                        Sign In
                                    </button>
                                </div>
                            </div>
                            {/* Horizontal line between Sign In and SSO buttons */}
                            <hr className="my-4" />
                            {showSpinner ? (
                                <Spinner />
                            ) : (
                                <>
                                    <div className="mt-3">
                                        <button
                                            className="btn btn-block mb-2"
                                            style={{
                                                backgroundColor: "#fff",
                                                color: "#222",
                                                border: "1px solid #ddd",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontWeight: 500,
                                                fontSize: "16px",
                                                gap: "8px",
                                            }}
                                            onClick={async () => {
                                                try {
                                                    const returnUriPath =
                                                        sessionStorage.getItem(
                                                            "postAuthRedirect"
                                                        ) || "/";

                                                    const query =
                                                        new URLSearchParams({
                                                            client_id:
                                                                process.env
                                                                    .REACT_APP_STAREK_AUTH_CLIENT_ID,
                                                            response_type:
                                                                "code",
                                                            scope: "email openid",
                                                            redirect_uri: `${process.env.REACT_APP_HOST}/sso-authenticate`,
                                                            state: JSON.stringify(
                                                                {
                                                                    workspace,
                                                                    returnUriHost: `${process.env.REACT_APP_HOST}`,
                                                                    returnUriPath,
                                                                }
                                                            ),
                                                        });
                                                    const uri = `${
                                                        process.env
                                                            .REACT_APP_STAREK_AUTH_URI
                                                    }/login?${query.toString()}`;
                                                    window.location.href = uri;
                                                } catch (e) {
                                                    starekContext?.showError(
                                                        "Sign in failed: Please check Workspace, Username and Password."
                                                    );
                                                    setShowSpinner(false);
                                                }
                                            }}
                                            disabled={!workspace}
                                        >
                                            <img
                                                src="https://00117-starek.s3.us-east-1.amazonaws.com/branding/dark-starek-logo-80x80.png"
                                                alt="Starek"
                                                style={{
                                                    width: "24px",
                                                    height: "24px",
                                                    borderRadius: "50%",
                                                }}
                                            />
                                            Sign in with Starek
                                        </button>
                                        {/* <button
                                            className="btn btn-block mb-2"
                                            style={{
                                                backgroundColor: "#fff",
                                                color: "#444",
                                                border: "1px solid #ddd",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontWeight: 500,
                                                fontSize: "16px",
                                                gap: "8px",
                                            }}
                                            onClick={() =>
                                                (window.location.href =
                                                    "/sso-authenticate-google")
                                            }
                                            disabled={!workspace}
                                        >
                                            <img
                                                src="https://developers.google.com/identity/images/g-logo.png"
                                                alt="Google"
                                                style={{
                                                    width: "20px",
                                                    height: "20px",
                                                }}
                                            />
                                            Sign in with Google
                                        </button> */}
                                        <div className="form-check mt-3">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="termsCheckbox"
                                                checked={termsAccepted}
                                                onChange={(e) =>
                                                    setTermsAccepted(
                                                        e.target.checked
                                                    )
                                                }
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="termsCheckbox"
                                            >
                                                By signing in, you accept our{" "}
                                                <a href="/onboard">
                                                    terms & conditions
                                                </a>
                                                .
                                            </label>
                                        </div>
                                    </div>
                                </>
                            )}
                        </>
                    </div>
                </div>

                <div className="text-white" style={{ textAlign: "center" }}>
                    <br />
                    Structured Telemetry and Reporting
                </div>
                {/* PositiveSSL Trust Seal */}
                <PositiveSSLSeal />
            </div>
        </div>
    );
}

export default Login;
